"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NavList = _interopRequireDefault(require("../NavList"));
var _constants = _interopRequireDefault(require("../../utils/constants"));
var _LumeThemeService = _interopRequireDefault(require("../LumeThemeService/LumeThemeService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var styles = {
  "profile": "styles__profile__cHraC",
  "details": "styles__details__gJME3",
  "name": "styles__name__rusFO",
  "user-name": "styles__user-name__qSGZ6",
  "userName": "styles__user-name__qSGZ6"
}; 
require('./styles.css');
var ignorePopoverClickClass = _constants["default"].ignorePopoverClickClass;
var displayName = 'Profile';
var propTypes = {
  /** link for signout */
  signOutLink: _propTypes["default"].string,
  /** is inside studio */
  isStudio: _propTypes["default"].bool,
  /** callback for Signout */
  onSignout: _propTypes["default"].func,
  /** is subscriptionAndUsageLink visible */
  showSubscriptionAndUsageLink: _propTypes["default"].bool,
  /** Lume Theme Service */
  lumeThemeService: _LumeThemeService["default"],
  /** is using cookie preferences from one trust */
  isOneTrustEnabled: _propTypes["default"].bool,
  /** profile object of the current user */
  profile: _propTypes["default"].shape({
    firstName: _propTypes["default"].string,
    lastName: _propTypes["default"].string,
    username: _propTypes["default"].string
  })
};
var defaultProps = {
  signOutLink: '/',
  isStudio: false,
  showSubscriptionAndUsageLink: false,
  lumeThemeService: null,
  isOneTrustEnabled: false,
  onSignout: null,
  profile: null
};
var Profile = function Profile(_ref) {
  var onSignout = _ref.onSignout,
    profile = _ref.profile,
    isStudio = _ref.isStudio,
    showSubscriptionAndUsageLink = _ref.showSubscriptionAndUsageLink,
    lumeThemeService = _ref.lumeThemeService,
    isOneTrustEnabled = _ref.isOneTrustEnabled,
    signOutLink = _ref.signOutLink;
  var firstName = profile.firstName,
    lastName = profile.lastName,
    username = profile.username;
  var profileListItems = [];
  if (!isStudio) {
    if (lumeThemeService !== null && lumeThemeService !== void 0 && lumeThemeService.canEnable()) {
      profileListItems.push({
        onClick: lumeThemeService.toggle.bind(lumeThemeService),
        name: lumeThemeService.getLabel(),
        lumedev: true
      });
    }
    if (showSubscriptionAndUsageLink) {
      profileListItems.push({
        href: '/metering',
        icon: 'usage-small',
        name: 'Usage'
      });
    }
    profileListItems.push({
      href: '/accounts/#/cs/profile/view',
      icon: 'user',
      name: 'Profile'
    });
    profileListItems.push({
      href: 'https://www.mulesoft.com/privacy-policy',
      icon: 'studio-project',
      name: 'Privacy Policy',
      target: '_blank'
    });
  }
  var isOneTrustScriptPresent = global && global.Optanon && global.Optanon.ToggleInfoDisplay;
  if (isOneTrustEnabled && isOneTrustScriptPresent) {
    profileListItems.push({
      onClick: global.Optanon.ToggleInfoDisplay,
      icon: 'settings',
      name: 'Cookie Preferences'
    });
  }
  profileListItems.push({
    href: signOutLink,
    icon: 'sign-out',
    name: 'Sign Out',
    onClick: onSignout
  });
  var profileClasses = (0, _classnames["default"])(styles.profile, ignorePopoverClickClass);
  var detailsClasses = (0, _classnames["default"])(styles.details, ignorePopoverClickClass);
  var nameClasses = (0, _classnames["default"])(styles.name, ignorePopoverClickClass, 'fs-block');
  var userNameClasses = (0, _classnames["default"])(styles.userName, ignorePopoverClickClass, 'fs-block');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: profileClasses,
    "data-test-id": "navbar-profile"
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: detailsClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: nameClasses
  }, "".concat(firstName, " ").concat(lastName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: userNameClasses
  }, username)), /*#__PURE__*/_react["default"].createElement(_NavList["default"], {
    items: profileListItems
  }));
};
Profile.displayName = displayName;
Profile.defaultProps = defaultProps;
Profile.propTypes = propTypes;
var _default = exports["default"] = Profile;
//# sourceMappingURL=Profile.js.map